import { IModalDescription } from '@cp/shared/modal';
import type { ClientTypeModalProps } from '../ui/clientTypeModal';

export const CLIENT_TYPE_MODAL: IModalDescription<ClientTypeModalProps> = {
  nss: 'clientType',
  loader: () => import('../ui/clientTypeModal').then((m) => m.ClientTypeModal),
};
